import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cart.svg';
export default {
  name: 'TrendInspiration',
  props: {
    context: {
      type: String,
      required: true
    },
    reference: {
      type: String,
      required: true
    },
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    negativeText: {
      type: Boolean,
      default: false
    },
    videoMp4: {
      type: String,
      default: ''
    },
    webm: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    layer: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread({}, mapGetters({
    items: 'layer/items'
  })),
  mounted: function mounted() {
    var payload = {
      reference: this.reference,
      src: this.src
    };
    this.appendItems(payload);
  },
  methods: _objectSpread({}, mapActions({
    setCurrentLayer: 'layer/setCurrentLayer',
    appendItems: 'layer/appendItems'
  }), {
    openLayer: function openLayer() {
      this.$root.$emit('open-layer', {
        state: true,
        name: 'LayerProduct',
        context: this.context,
        backgroundColor: this.backgroundColor,
        items: this.items
      });
      this.setCurrentLayer({
        item: {
          reference: this.reference,
          src: this.src
        },
        index: this.reference
      });
      return false;
    }
  })
};